export function getStatusColor(status) {
  const lowercaseStatus = status?.toLowerCase();

  switch (lowercaseStatus) {
    case 'verified':
    case 'complete':
    case 'completed':
    case 'deposit':
    case 'credit':
    case 'successful':
    case 'low_risk':
      return 'bg-success20 text-success';
    case 'pending':
    case 'medium_risk':
      return 'bg-pending20 text-pending';
    case 'not verified':
    case 'not_verified':
      return 'text-white bg-status-404';
    case 'debit':
    case 'failed':
    case 'withdraw':
    case 'withdrawal':
    case 'high_risk':
      return 'bg-[#A13E3F2B] text-status-404';
    default:
      return '';
  }
}

export function getSubCategoriesColor(subCategory) {
  const lowercaseSubCategory = subCategory?.toLowerCase();

  switch (lowercaseSubCategory) {
    case 'pep':
      return 'text-success bg-success20';
    case 'adverse-media':
      return 'text-brandBlue50 bg-batchBlue20';
    default:
      return '';
  }
}
export function getReconColor(reconType) {
  const lowercaseSubCategory = reconType?.toLowerCase();

  switch (lowercaseSubCategory) {
    case 'reconciled':
      return 'bg-[#3F7CDB]';
    case 'unreconciled':
      return 'bg-[#242424]';
    default:
      return '';
  }
}
